import styled from 'styled-components';

export const TeamCalendarWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  //background: ${props => props.theme.colors.mainColor};
`;

export const WidgetHeader = styled.div` 
  width: 100%;
  padding: 10px 0;
  text-align: center;
`;




// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/TeamCalendarWidgetGazzanet/styles.js